<script>
    import accounting from 'accounting';

    export default {
        functional: true,
        props: {
            amount: {
                required: true,
                type: Number,
            },
            inline: {
                required: false,
                type: Boolean,
                default: false,
            },
            lineThrough: {
                required: false,
                type: Boolean,
                default: false,
            },
            precision: {
                required: false,
                type: Number,
                default: 2,
            },
        },
        render(createElement, { data, props }) {
            return createElement('div', Object.assign(data, {
                class: ['price-block', {
                    'line-through': props.lineThrough,
                    'price-block-inline': props.inline,
                }],
                domProps: {
                    innerHTML: accounting.formatMoney(
                        props.amount,
                        '<span class="price-block-currency mr-1">€</span>',
                        props.precision,
                        '<span class="price-block-thousands">.</span>',
                        ',',
                    ),
                },
            }));
        },
    };
</script>
